/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";

const SafariDownloadIcon: any = (props: {}) => {
  return (
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none">
      <path
        d="M7.24534 12.0914C7.59658 12.0914 7.89881 11.7961 7.89881 11.4516V3.02695L7.8498 1.79648L8.39708 2.37891L9.63867 3.70781C9.75303 3.83906 9.9164 3.90469 10.0798 3.90469C10.4147 3.90469 10.6761 3.65859 10.6761 3.32227C10.6761 3.15 10.6025 3.01875 10.48 2.8957L7.71911 0.221484C7.55574 0.0574219 7.41688 0 7.24534 0C7.08197 0 6.94311 0.0574219 6.77158 0.221484L4.01067 2.8957C3.88814 3.01875 3.8228 3.15 3.8228 3.32227C3.8228 3.65859 4.06785 3.90469 4.41092 3.90469C4.56612 3.90469 4.74582 3.83906 4.86018 3.70781L6.0936 2.37891L6.64905 1.79648L6.60004 3.02695V11.4516C6.60004 11.7961 6.8941 12.0914 7.24534 12.0914ZM2.56487 18.5145H11.934C13.6412 18.5145 14.4988 17.6613 14.4988 15.9715V7.78477C14.4988 6.09492 13.6412 5.2418 11.934 5.2418H9.65501V6.5625H11.9095C12.7181 6.5625 13.1837 7.00547 13.1837 7.85859V15.8977C13.1837 16.7508 12.7181 17.1938 11.9095 17.1938H2.5812C1.76437 17.1938 1.31511 16.7508 1.31511 15.8977V7.85859C1.31511 7.00547 1.76437 6.5625 2.5812 6.5625H4.84384V5.2418H2.56487C0.857678 5.2418 0 6.09492 0 7.78477V15.9715C0 17.6613 0.857678 18.5145 2.56487 18.5145Z"
        fill="black"
      />
    </svg>
  );
};

export default SafariDownloadIcon;
